// APP TEXT
export const APP_TITLE = 'ContactsApp';
export const APP_DESCRIPTION = 'MADE IN 2022';
export const FOOTER_TEXT = `${new Date().getFullYear()} ContactsApp`;
// PAGES TITLE
export const PAGE_TITLE_HOME = 'Home';
export const PAGE_TITLE_DASHBOARD = 'Dashboard';
export const PAGE_TITLE_GH_PRIVATE = 'GitHub Private';
export const PAGE_TITLE_GH_PUBLIC = 'GitHub Public';
export const PAGE_TITLE_CODE = 'Code Editor';
export const PAGE_TITLE_SETTINGS = 'Settings';
export const PAGE_TITLE_PREFERENCES = 'Preferences';
// UI CONSTANTS
export const FOOTER_HEIGHT = 30;
export const HEADER_HEIGHT = 60;
export const DRAWER_WIDTH = 250;
// APP THEME
export const DARK_MODE_THEME = 'dark';
export const LIGHT_MODE_THEME = 'light';
// BUSINESS LOGIC
export const PERSON_PARTY_TYPE_ID = 1;
export const ORGANIZATION_PARTY_TYPE_ID = 2;
export const PARTY_RELATIONSHIP_CATEGORY_ORGANIZATION_ORGANIZATION = 'o-o';
export const PARTY_RELATIONSHIP_CATEGORY_ORGANIZATION_PERSON = 'o-p';
export const PARTY_RELATIONSHIP_CATEGORY_PERSON_PERSON = 'p-p';

